<template>
  <div ref="layout">
    <!-- 查看报表 -->
    <!-- <redOrderList
      v-show="activeName === 'create'"
      ref="create"
      @changeActive="changeActive"
    /> -->
    <!-- 选中的多条数据展示 -->
    <CreateRedOrder
      v-show="activeName === 'create'"
      :invo-infoid="invoInfoid"
      :ticket-type="ticketType"
      ref="create"
      @changeActive="changeActive"
    />
    <!-- 查看详情 -->
    <redOrderDetail
      v-if="activeName === 'entry'"
      :select-data="checkedData"
      :red-rush-id="redRushId"
      :ticket-type="ticketType"
      :from-page="fromPage"
      @edit-workbench="delWorkbench"
      @changeActive="changeActive"
    />
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import CheckeOrder from './components/CheckeOrder.vue'
import redOrderList from './components/redOrderList.vue'
import redOrderDetail from './components/redOrderDetail.vue'
import CreateRedOrder from './components/CreateRedOrder.vue'
export default {
  components: { redOrderList, CheckeOrder, redOrderDetail, CreateRedOrder },
  data() {
    return {
      activeName: 'create',
      fromPage: '',
      inf_type: '',
      workbenchList: [],
      checkedData: [],
      ticketType: '',
      redRushId: '',
      invoInfoid: '',
    }
  },
  watch: {
    
  },
  created() {
   
  },
  methods: {
    delWorkbench(invo_infoid) {
      // this.workbenchList[this.checkedData._index].invo_infoid = invo_infoid
    },
    changeActive(activeName, id, checkedData, redRushId='', ticketType='') {
      this.invoInfoid = id
      checkedData && (this.checkedData = checkedData)
      this.ticketType = ticketType
      this.activeName = activeName
      this.redRushId = redRushId
    },
    deleteWorkbench() {},
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  text-align: left;
  padding: 0 20px 20px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice-manage/makeRedOrderData.vue